import React from 'react';

import Title from './Title';
import Body from './Body';
import Container from './Container';
import OrderedList from './OrderedList';

export default () => (
  <Container>
    <Title>How it works</Title>
    <Body>
      <p>Congrats! You have successfully setup your offer for purchasing. Now what’s next?</p>
      <OrderedList>
        <li>
          <p>
            Use your offer to purchase an item from sellers on marketplaces like Letgo, offerup and Facebook
            marketplace.
          </p>
          <p>Just send the offer to your seller to complete a purchase.</p>
        </li>
        <li>
          Once the seller accepts your offer, you’ll get a notification to choose your preferred shipping option.
        </li>
        <li>Item is delivered to your doorstep!</li>
      </OrderedList>
    </Body>
  </Container>
);
